import ApiResponse from "../ApiResponse";
import { GetStudioResponse } from "./types";
import { makeGetRequest } from "../utils";

export const getStudio = async (): Promise<ApiResponse<GetStudioResponse>> =>
  await makeGetRequest<GetStudioResponse>("/api/studio");
